import { SelectList } from "@swa-ui/core";
import { withFormField } from "@swa-ui/form";

/**
 * SelectListFormField provides support for a standard SelectList
 * component to be used in a Form.
 */
export const SelectListFormField = withFormField(SelectList, {
  useController: true,
});
